import React from 'react'
import { Link } from 'react-router-dom'
import Services from '../../api/service'


const WhyChoose = (props) => {

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    


    return(
        <div className="why-choose-section">
            {/* <h3>Our Services</h3> */}
            <div className="feature-grids clearfix">
                {Services.slice(0,8).map((service, sitem) => (
                    <div className="grid" key={sitem}>
                        <div className="icon">
                             <i className={`fi ${service.fIcon}`}></i>
                        </div>
                        <div className="hover-icon">
                             <i className={`fi ${service.fIcon}`}></i>
                        </div>
                        <h3><Link className='text-decoration-none' onClick={ClickHandler} to={`#`}>{service.title}</Link></h3>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default WhyChoose;
